if (!customElements.get('card-image-slider')) {
  customElements.define(
    'card-image-slider',
    class CardImageSlider extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.track = this.querySelector('.multicolumn-card__slider-track');
        this.items = this.track ? Array.from(this.track.children) : [];
        this.prevButton = this.querySelector('[data-card-slider-prev]');
        this.nextButton = this.querySelector('[data-card-slider-next]');
        this.currentEl = this.querySelector('.card-slider-counter--current');
        this.totalEl = this.querySelector('.card-slider-counter--total');

        if (!this.track || this.items.length < 2) return;

        if (this.totalEl) this.totalEl.textContent = this.items.length;

        this.track.addEventListener('scroll', this.onScroll.bind(this));
        if (this.prevButton) this.prevButton.addEventListener('click', () => this.go(-1));
        if (this.nextButton) this.nextButton.addEventListener('click', () => this.go(1));

        this.onScroll();
      }

      go(direction) {
        const width = this.track.clientWidth;
        this.track.scrollBy({ left: direction * width, behavior: 'smooth' });
      }

      onScroll() {
        const width = this.track.clientWidth || 1;
        const index = Math.max(0, Math.min(this.items.length - 1, Math.round(this.track.scrollLeft / width)));
        if (this.currentEl) this.currentEl.textContent = index + 1;
        if (this.prevButton) this.prevButton.toggleAttribute('disabled', index <= 0);
        if (this.nextButton) this.nextButton.toggleAttribute('disabled', index >= this.items.length - 1);
      }
    }
  );
}
